<template>
    <span
        :title="title || text"
        class="co pill mw-100"
        :class="{
            outline: outline,
            truncate: truncate,
            [variant]: true,
            iconleft: iconleft,
            iconright: iconright,
            [size]: true,
            'has-text': (text && text.length > 0) || $slots.default,
        }"
    >
        <div class="d-flex align-items-center w-100 h-100">
            <CoIcon v-if="iconleft" :name="iconleft" :size="size === 'ms' ? '.8rem' : null" />
            <span v-if="text || $slots.default" class="mw-0 flex-fill"
                ><slot>{{ text }}</slot></span
            >
            <CoIcon v-if="iconright" :name="iconright" :size="size === 'ms' ? '.8rem' : null" />
        </div>
    </span>
</template>
<style lang="less" scoped>
@import './CoPill.less';
</style>
<script>
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';

export default {
    name: 'CoPill',
    components: {
        CoIcon,
    },
    props: {
        text: {
            type: String,
            default: null,
            required: false,
        },
        title: {
            type: String,
            default: null,
            required: false,
        },
        outline: {
            type: Boolean,
            default: false,
        },
        truncate: {
            type: Boolean,
            default: true,
        },
        variant: {
            type: String,
            default: 'normal',
            validators: (value) =>
                [
                    'normal',
                    'mute',
                    'success',
                    'warning',
                    'primary',
                    'white',
                    'black',
                    'lightgrey',
                    'outline',
                    'dashed-border',
                ].includes(value),
        },
        iconleft: {
            type: String,
            required: false,
            default: '',
        },
        iconright: {
            type: String,
            required: false,
            default: '',
        },
        size: {
            type: String,
            default: 'md',
            validator: (value) => ['ms', 'md'].includes(value),
        },
    },
};
</script>
